import { Link } from 'react-router-dom';
import { Clock, Star, ArrowRight, BadgeCheck, Lock } from 'lucide-react';
import { ArtistImage } from '../ArtistImage';

const GENRE_CONFIG = {
  'dancehall': { label: 'Dancehall', color: 'bg-lime/20 text-lime border-lime/30' },
  'reggae': { label: 'Reggae', color: 'bg-green-500/20 text-green-400 border-green-500/30' },
  'soca': { label: 'Soca', color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30' }
};

export function ArtistListItem({ artist, index, canSeePrices, isArtist }) {
  return (
    <Link to={`/artist/${artist.id}`} className="block bg-surface border border-[#262626] rounded-xl p-4 hover:border-lime transition-colors group" data-testid={`artist-list-${index}`}>
      <div className="flex gap-4 sm:gap-6">
        <div className="w-24 h-24 sm:w-32 sm:h-32 flex-shrink-0 rounded-lg overflow-hidden">
          <ArtistImage src={artist.image_url} alt={artist.name} name={artist.name} className="w-full h-full object-cover" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="font-heading text-lg sm:text-xl font-bold group-hover:text-lime transition-colors flex items-center gap-2">
                {artist.name}
                {artist.is_verified && <BadgeCheck className="w-5 h-5 text-blue-400" />}
              </h3>
              {artist.genres?.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-1">
                  {artist.genres.slice(0, 3).map(genre => (
                    <span key={genre} className={`text-xs px-2 py-0.5 rounded-full border ${GENRE_CONFIG[genre]?.color || 'bg-gray-500/20 text-gray-400 border-gray-500/30'}`}>
                      {GENRE_CONFIG[genre]?.label || genre}
                    </span>
                  ))}
                </div>
              )}
              <p className="text-sm text-[#A1A1AA] line-clamp-2 mt-1">{artist.bio}</p>
            </div>
            {canSeePrices ? (
              <span className="price-tag flex-shrink-0">${artist.price.toFixed(2)}</span>
            ) : (
              <span className="price-tag flex-shrink-0 flex items-center gap-1">
                <Lock className="w-3 h-3" />
                {isArtist ? 'N/A' : 'Login'}
              </span>
            )}
          </div>
          <div className="flex flex-wrap items-center gap-4 mt-3 text-sm text-[#666]">
            <div className="flex items-center gap-1"><Clock className="w-4 h-4" /><span>{artist.delivery_days} days</span></div>
            {canSeePrices && artist.average_rating && (
              <div className="flex items-center gap-1">
                <Star className="w-4 h-4 text-lime fill-lime" />
                <span className="text-lime">{artist.average_rating}</span>
                <span className="text-[#666]">({artist.total_reviews} reviews)</span>
              </div>
            )}
            {artist.total_orders > 0 && <span>{artist.total_orders} completed</span>}
          </div>
        </div>
        <ArrowRight className="w-5 h-5 text-lime opacity-0 group-hover:opacity-100 transition-opacity self-center hidden sm:block" />
      </div>
    </Link>
  );
}
